import { render, staticRenderFns } from "./EmployeeConfigAccess.vue?vue&type=template&id=59bcd4d1&"
import script from "./EmployeeConfigAccess.vue?vue&type=script&lang=js&"
export * from "./EmployeeConfigAccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports